import DrawerComponent from "@/components/DrawerComponent";
import { HeaderComponent } from "@/components/headerComponet";
import styles from './Configuracoes.module.css'
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { User } from "@/services/UserService";
import { usuarioApi } from "@/services/api/usuario";
import { Botao } from "@/components/Botao";
import { ModalComponent } from "../home/Components/Modal";
import { CadastraUsuario } from "./cadastraUsuario";
import { CustomSnackbar, severityType } from "@/utils/alert";
import { ConfirmModal } from "@/components/ConfirmModal";

export function Configuracoes() {
    const [linhas, setLinhas] = useState<GridRowsProp>([]);
    const [linhaUsuarioId, setLinhaUsuarioId] = useState<string | number>()

    const [editarUsuario, setEditarUsuario] = useState(false)
    const [usuarioDeletado, setUsuarioDeletado] = useState(false)
    const [abreModalUsuario, setAbreModalUsuario] = useState(false)
    const [descricaoUsuario, setDescricaoUsuario] = useState('')
    const [ordenacao, setOrdenacao] = useState<string>('Mais Recente')

    const [alertInfo, setAlertInfo] = useState<{
        severity: severityType
        message: string
    }>({ severity: 'success', message: '' })
    const [showAlert, setShowAlert] = useState(false)
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [opcoes, setOpcao] = useState('Usuários')

    async function listarUsuarios() {
        try {
            const usuarios = await usuarioApi.buscarTodosUsuarios()
            const usuariosLinha = usuarios.data.map((usuario: User) => {
                return {
                    id: usuario.id,
                    nome: usuario.nome,
                    email: usuario.email,
                    telefone: usuario.telefone,
                    papel: usuario.papel,
                }
            });
            setLinhas(usuariosLinha)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        listarUsuarios()
        setUsuarioDeletado(false)
    }, [editarUsuario, usuarioDeletado, abreModalUsuario])

    function linhaSelecionada(params: any) {
        setLinhaUsuarioId(params.row.id)
    }

    function editaUsuario() {
        setAbreModalUsuario(true)
        setEditarUsuario(true)
    }

    async function desejaDeletarUsuario() {
        setOpenConfirmModal(true);
    }

    async function deletaUsuario(usuarioId: string | number) {
        try {
            await usuarioApi.deletarUsuario(usuarioId)
            setUsuarioDeletado(true)
        } catch (error) {
            console.error(error)
        }
    }

    function confirmaRemocaoUsuario() {
        if (linhaUsuarioId) {
            deletaUsuario(linhaUsuarioId)
            setOpenConfirmModal(false);
        }
    }

    function cancelaRemocaoUsuario() {
        setOpenConfirmModal(false);
    };

    async function cadastrarUsuario() {
        setEditarUsuario(false)
        setAbreModalUsuario(true)
    }

    const colunas: GridColDef[] = [
        { field: 'nome', headerName: 'Nome', minWidth: 350, editable: false },
        { field: 'email', headerName: 'Email', minWidth: 350, editable: false },
        { field: 'telefone', headerName: 'Telefone', minWidth: 250, editable: false },
        { field: 'papel', headerName: 'Papel', minWidth: 250, editable: false },
        {
            field: "acoes",
            headerName: "Ações",
            sortable: false,
            minWidth: 450,
            renderCell: (params) => (
                <div className={styles.botoes_acao}>
                    <Botao
                        corDeFundo="#666CFF"
                        cor='#F7F7F9'
                        largura="8rem"
                        altura="2.4rem"
                        texto="EDITAR"
                        onClick={editaUsuario}
                    />
                    <Botao
                        corDeFundo="#E9775F"
                        cor='#F7F7F9'
                        largura="8rem"
                        altura="2.4rem"
                        texto="DELETAR"
                        onClick={() => desejaDeletarUsuario()}
                    />
                </div>
            ),
        },
    ];

    function selecionaOpcao() {
        setOpcao("usuarios")
    }

    function handleEventoRealizado(retorno: string) {
        if (retorno === 'cadastrado') {
            setAlertInfo({
                severity: 'success',
                message: 'Usuário criado com sucesso.',
            })
            setShowAlert(true)
            setAbreModalUsuario(false)
        } else if (retorno === 'atualizado') {
            setAlertInfo({
                severity: 'success',
                message: 'Usuário atualizado com sucesso.',
            })
            setShowAlert(true)
            setAbreModalUsuario(false)
        } else if (retorno === 'erro criar') {
            setAlertInfo({
                severity: 'error',
                message: 'Erro ao tentar criar usuário.',
            })
            setShowAlert(true)
            setAbreModalUsuario(false)
        } else if (retorno === 'erro atualizar') {
            setAlertInfo({
                severity: 'error',
                message: 'Erro ao tentar atualizar.',
            })
            setShowAlert(true)
            setAbreModalUsuario(false)
        }
    }

    function handleAlertClose() {
        setShowAlert(false)
    }

    async function buscarPorUsuario() {
        try {
            const ordena = ordenacao === 'Mais Recente' ? 'recente' : 'antigo'
            const resposta = await usuarioApi.buscarPorUsuario({
                descricao: descricaoUsuario,
                ordenacao: ordena
            })
            const usuariosLinha = resposta.data.map((usuario: User) => {
                return {
                    id: usuario.id,
                    nome: usuario.nome,
                    email: usuario.email,
                    telefone: usuario.telefone,
                    papel: usuario.papel,
                }
            });
            setLinhas(usuariosLinha)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        buscarPorUsuario()
    }, [descricaoUsuario, ordenacao])

    return (
        <>
            <HeaderComponent />
            <DrawerComponent />
            <CustomSnackbar
                open={showAlert}
                severity={alertInfo.severity}
                message={alertInfo.message}
                handleClose={handleAlertClose}
            />

            <div className={styles.container_configuracoes}>
                <header>
                    <h1 className={styles.titulo_pagina_configuracoes}>Configurações</h1>
                </header>

                <div className={styles.container_conteudo}>
                    <header className={styles.container_opcoes}>
                        <div className={styles.lista_opcoes}>
                            <button onClick={selecionaOpcao} className={opcoes === 'Usuários' ? styles.opcao_selecionada : ''}>
                                Usuários
                            </button>
                        </div>
                        <div className={styles.filtro_e_cadastro}>
                            <div className={styles.filtro_por_e_busca}>
                                <div className={styles.filtrar_por}>
                                    <span>Filtrar por:</span>
                                    <select onChange={(e) => setOrdenacao(e.target.value)}>
                                        <option value="Mais Recente">Mais Recente</option>
                                        <option value="Menos Recente">Menos Recente</option>
                                    </select>
                                </div>
                                <div className={styles.buscar}>
                                    <input type="text" onChange={(e) => setDescricaoUsuario(e.target.value)} placeholder="Busca" />
                                </div>
                            </div>
                            <div className={styles.cadastrar_usuario}>
                                <Botao
                                    onClick={cadastrarUsuario}
                                    texto="CADASTRAR USUÁRIO"
                                    corDeFundo="#666CFF"
                                    cor="#F7F7F9"
                                    largura="14rem"
                                    altura="2.6rem"
                                />
                            </div>
                        </div>

                    </header>
                    <main className={styles.container_tabela}>
                        <DataGrid
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    paddingLeft: '2rem'
                                },
                                '& .MuiDataGrid-cell': {
                                    paddingLeft: '2rem',
                                    display: 'flex',
                                    alignItems: 'center'
                                },
                            }}
                            columns={colunas}
                            rows={linhas}
                            className={styles.tabela}
                            onRowClick={linhaSelecionada}
                        />

                        <ModalComponent onClose={() => { setAbreModalUsuario(false) }} open={abreModalUsuario}>
                            <div>
                                <div>
                                    <div>
                                        <h1 className={styles.titulo_pagina_cadastro}>
                                            {editarUsuario ? 'Atualizar usuário' : 'Criar um novo usuário'}
                                        </h1>
                                    </div>
                                    <CadastraUsuario usuarioId={linhaUsuarioId} atualizar={editarUsuario} onCadastroOuAtualizacaoRealizado={handleEventoRealizado} />
                                </div>
                            </div>
                        </ModalComponent>

                        <ConfirmModal
                            open={openConfirmModal}
                            onClose={cancelaRemocaoUsuario}
                            onConfirm={confirmaRemocaoUsuario}
                            title="Confirmar remoção de usuário"
                            description="Você tem certeza que deseja remover este usuário?"
                            confirmText="Confirmar"
                            cancelText="Cancelar"
                            confirmButtonStyle={{
                                color: '#F7F7F9',
                                backgroundColor: 'var(--primary-color)',
                                '&:hover': { backgroundColor: 'var(--primary-color-dark)' }
                            }}
                            cancelButtonStyle={{
                                color: 'var(--text)',
                                backgroundColor: 'var(--border-color-2)',
                                '&:hover': { backgroundColor: '#aaaaaa' }
                            }}
                        />
                    </main>
                </div>
            </div>
        </>
    )
}